import { render, staticRenderFns } from "./ChangeLocale.vue?vue&type=template&id=32f588d0&scoped=true"
import script from "./ChangeLocale.vue?vue&type=script&lang=ts"
export * from "./ChangeLocale.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f588d0",
  null
  
)

export default component.exports